import type { IconProps } from '../types/IconProps.ts';
export const User: IconProps = {
    name: 'User',
    children: [
        `<circle cx="12" cy="8" r="5" />`,
        `<path d="M20 21a8 8 0 1 0-16 0" />`,
    ]
};